import { __awaiter, __generator } from "tslib";
import { fetchGet } from '../../../common/http/fetch-get';
import { getSFCCRequestHeaders } from '../../../sfcc/utilities/get-sfcc-request-headers';
import { getPricingApiConfig } from '../config/actions';
import { getFetchPricesUrlGet } from '../utilities/get-fetch-prices-url.get';
import { getFetchSFCCPricesUrlGetByIds } from '../utilities/get-fetch-sfcc-prices-url-by-ids.get';
/**
 * @internal
 */
export var fetchPricesGetByIds = function (entityIds, productType) { return __awaiter(void 0, void 0, void 0, function () {
    var isSFCCPricingOn, url, requestOptions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                isSFCCPricingOn = getPricingApiConfig().isSFCCPricingOn;
                requestOptions = {};
                if (!isSFCCPricingOn) return [3 /*break*/, 2];
                url = getFetchSFCCPricesUrlGetByIds(entityIds, productType);
                return [4 /*yield*/, getSFCCRequestHeaders()];
            case 1:
                requestOptions = _a.sent();
                return [3 /*break*/, 3];
            case 2:
                url = getFetchPricesUrlGet(entityIds, productType);
                _a.label = 3;
            case 3: return [4 /*yield*/, fetchGet(url, requestOptions)];
            case 4: return [2 /*return*/, _a.sent()];
        }
    });
}); };
